;(function () {
  if (window.giftCenterFiltersInitialized) return
  window.giftCenterFiltersInitialized = true

  const MAX_VISIBLE_PER_SECTION = 4
  const YOTPO_RATING_CACHE_KEY = "__yotpoRatingCache"

  const SELECTORS = {
    section: "[data-gift-center-section]",
    item: "[data-gift-center-item]",
    filterPill: "[data-gift-center-filter-pill]",
  }

  const CLASSES = {
    hiddenItem: "gift-center-item--hidden",
    defaultHiddenItem: "gift-center-item--default-hidden",
    hiddenSection: "gift-center-section--hidden",
    pillActive: "selected",
  }

  let _closePriceDropdownFn = null
  let _closeRatingDropdownFn = null

  function getPillType(pill) {
    const key = (pill?.dataset?.paramKey || "").trim()
    if (key === "yotpo_rating_min") return "rating_min"
    if (key === "most_gifted") return "most_gifted"
    if (key === "filter.p.m.custom.most_popular") return "most_popular"
    return "url_only"
  }

  function getParams() {
    return new URLSearchParams(window.location.search)
  }

  function getMinRatingFromUrl() {
    const params = getParams()
    const raw = (params.get("yotpo_rating_min") || "").trim()
    if (!raw) return null
    const v = Number.parseFloat(raw)
    return Number.isFinite(v) ? v : null
  }

  function getPriceMaxFromUrl() {
    const params = getParams()
    const raw = (params.get("price_max") || "").trim()
    if (!raw) return null
    const v = Number.parseInt(raw, 10)
    return Number.isFinite(v) && v > 0 ? v : null
  }

  function getMostGiftedFromUrl() {
    const params = getParams()
    return (params.get("most_gifted") || "").trim() === "1"
  }

  /** Returns array of selected most_popular values so multiple pills (e.g. Back Pain + FSA/HSA) can be active. */
  function getMostPopularFromUrl() {
    const params = getParams()
    return params
      .getAll("filter.p.m.custom.most_popular")
      .map((v) => (v || "").trim())
      .filter(Boolean)
  }

  /** Set or remove one param; keeps all other URL params so multiple filters can be active. */
  function setParamInUrl(key, value) {
    const url = new URL(window.location.href)
    if (!key) return
    if (value == null || String(value).trim() === "")
      url.searchParams.delete(key)
    else url.searchParams.set(key, String(value))
    history.replaceState({}, "", url.toString())
  }

  /** Toggle one value in a multi-value param (e.g. filter.p.m.custom.most_popular). Adds if not present, removes if present. */
  function addOrRemoveParamValue(key, value) {
    const url = new URL(window.location.href)
    if (!key || (value || "").trim() === "") return
    const val = String(value).trim()
    const current = url.searchParams.getAll(key).map((v) => (v || "").trim())
    const hasValue = current.some((v) => v === val)
    const next = hasValue ? current.filter((v) => v !== val) : [...current, val]
    url.searchParams.delete(key)
    next.forEach((v) => url.searchParams.append(key, v))
    history.replaceState({}, "", url.toString())
  }

  function parseNumberLikeRating(raw) {
    const v = Number.parseFloat(String(raw || "").trim())
    if (!Number.isFinite(v)) return null
    if (v < 0 || v > 5) return null
    return v
  }

  function parseThreshold(raw) {
    const v = Number.parseFloat(String(raw || "").trim())
    return Number.isFinite(v) ? v : null
  }

  const yotpoRatingTools = (function getOrCreateYotpoRatingTools() {
    const cache =
      window[YOTPO_RATING_CACHE_KEY] || (window[YOTPO_RATING_CACHE_KEY] = {})
    return { cache }
  })()

  function getCachedRating(yotpoProductId) {
    if (!yotpoProductId) return null
    const v = yotpoRatingTools.cache[String(yotpoProductId)]
    return typeof v === "number" ? v : null
  }

  function cacheCardRatingFromItem(item) {
    const widget = item.querySelector(".yotpo-widget-instance")
    const id =
      (widget?.getAttribute("data-yotpo-product-id") || "").trim() || null
    let rating = null
    if (
      widget?.classList?.contains("yotpo-card-ready") &&
      widget?.classList?.contains("yotpo-card-suppressed")
    ) {
      rating = 0
    } else {
      const el = item.querySelector(
        ".yotpo-widget-instance .custom-yotpo-rating-number",
      )
      rating = el ? parseNumberLikeRating(el.textContent) : null
    }
    if (id && typeof rating === "number") {
      yotpoRatingTools.cache[String(id)] = rating
    }
    return { id, rating }
  }

  function getSwatchInputs(item) {
    return Array.from(
      item.querySelectorAll(".custom-swatches-check[data-yotpo-product-id]"),
    )
  }

  function clearAutoSwatchState(item) {
    try {
      delete item.dataset.yotpoRatingAutoSwatch
    } catch (_) {}
  }

  function readItemRating(item) {
    // Prefer the Yotpo-injected rating (supports swatch-specific ratings).
    const yotpoEl = item.querySelector(
      ".yotpo-widget-instance .custom-yotpo-rating-number",
    )
    if (yotpoEl) {
      const { id, rating } = cacheCardRatingFromItem(item)
      if (typeof rating === "number") return rating
      if (id) {
        const cached = getCachedRating(id)
        if (typeof cached === "number") return cached
      }
    }

    const fromDataset = parseNumberLikeRating(item?.dataset?.productRating)
    if (fromDataset != null) return fromDataset

    // Fallback: try to parse from any visible rating text in card contents.
    const card = item.querySelector(".card")
    const txt = (card?.textContent || "").replace(/\s+/g, " ")
    if (!txt) return null
    const m = txt.match(/\b([0-4](?:\.\d+)?|5(?:\.0+)?)\b/)
    return m ? parseNumberLikeRating(m[1]) : null
  }

  function setItemVisibility(item, visible) {
    item.classList.toggle(CLASSES.hiddenItem, !visible)
    if (visible) item.classList.remove(CLASSES.defaultHiddenItem)
  }

  function setSectionVisibility(sectionEl, visible) {
    const wrapper = sectionEl.closest(".shopify-section") || sectionEl
    wrapper.classList.toggle(CLASSES.hiddenSection, !visible)
  }

  function toggleEmptyState(show) {
    const el = document.querySelector("[data-gift-center-empty-state]")
    if (el) el.style.display = show ? "" : "none"
  }

  function sortByDefaultOrder(items) {
    return items.sort((a, b) => {
      const av = Number.parseInt(a.dataset.defaultOrder || "0", 10) || 0
      const bv = Number.parseInt(b.dataset.defaultOrder || "0", 10) || 0
      return av - bv
    })
  }

  let retryTimer = null
  let retryCount = 0

  function scheduleRetryIfNeeded(shouldRetry) {
    if (!shouldRetry) return
    if (retryTimer) return
    if (retryCount >= 12) return
    retryTimer = setTimeout(() => {
      retryTimer = null
      retryCount += 1
      applyGiftCenterFilters()
    }, 400)
  }

  /**
   * Get the visible price in cents from the card DOM (same as what the customer sees).
   * Falls back to data-filter-price if DOM price cannot be parsed.
   */
  function getVisiblePriceCents(item) {
    function parseMoneyNumberToCents(raw) {
      const s = String(raw || "").trim()
      if (!s) return null

      const hasDot = s.includes(".")
      const hasComma = s.includes(",")
      let normalized = s

      if (hasDot && hasComma) {
        const lastDot = s.lastIndexOf(".")
        const lastComma = s.lastIndexOf(",")
        // Assume the last separator is decimal; the other is thousands.
        if (lastDot > lastComma) {
          normalized = s.replaceAll(",", "")
        } else {
          normalized = s.replaceAll(".", "").replace(",", ".")
        }
      } else if (hasComma && !hasDot) {
        const parts = s.split(",")
        const last = parts[parts.length - 1] || ""
        // If the trailing part looks like cents, treat comma as decimal.
        if (last.length === 2) normalized = s.replace(",", ".")
        else normalized = s.replaceAll(",", "")
      } else {
        normalized = s.replaceAll(",", "")
      }

      const num = Number.parseFloat(normalized)
      if (!Number.isFinite(num) || num < 0) return null
      return Math.round(num * 100)
    }

    function parseMoneyTextToCents(text) {
      const t = String(text || "").trim()
      if (!t) return null
      const matches = t.match(/[\d.,]+/g) || []
      const cents = matches
        .map((m) => parseMoneyNumberToCents(m))
        .filter((v) => typeof v === "number")

      if (!cents.length) return null
      // Prefer the lowest number in case markup includes both sale + compare-at.
      return Math.min(...cents)
    }

    // Prefer custom sale price markup (metafield-driven sale_price_custom).
    const customSaleEl = item.querySelector(".price .sale_price_custom")
    if (customSaleEl) {
      const cents = parseMoneyTextToCents(customSaleEl.textContent)
      if (cents != null) return cents
    }

    // Prefer actual sale price (variant price) when compare_at is present.
    const saleEl = item.querySelector(".price .price-item--sale")
    if (saleEl) {
      const cents = parseMoneyTextToCents(saleEl.textContent)
      if (cents != null) return cents
    }

    // Otherwise use the regular price in the regular container (avoid compare-at).
    const regularEl =
      item.querySelector(".price .price__regular .price-item--regular") ||
      item.querySelector(".price .price-item--regular") ||
      item.querySelector(".price .price-item--last")
    if (regularEl) {
      const cents = parseMoneyTextToCents(regularEl.textContent)
      if (cents != null) return cents
    }

    const raw = (item.getAttribute("data-filter-price") || "").trim()
    if (raw) {
      const cents = Number.parseInt(raw, 10)
      if (Number.isFinite(cents) && cents >= 0) return cents
    }
    return null
  }

  function itemMatchesPrice(item, priceMaxDollars) {
    if (priceMaxDollars == null) return true
    const priceCents = getVisiblePriceCents(item)
    if (priceCents == null) return false
    const maxCents = priceMaxDollars * 100
    return priceCents <= maxCents
  }

  function itemMatchesMostGifted(item, filterActive) {
    if (!filterActive) return true
    return (item.dataset.mostGifted || "").trim() === "true"
  }

  function itemMatchesMostPopular(item, selectedValues) {
    if (!selectedValues || selectedValues.length === 0) return true
    const raw = (item.getAttribute("data-most-popular") || "").trim()
    if (!raw) return false
    const itemValues = raw.split(",").map((s) => s.trim())
    return selectedValues.some((selected) =>
      itemValues.some((v) => v === selected),
    )
  }

  function getRatingMatchState(item, minRating) {
    if (minRating == null) return { match: true, pending: false }

    const { rating } = cacheCardRatingFromItem(item)
    const current = typeof rating === "number" ? rating : readItemRating(item)

    if (typeof current === "number") {
      return { match: current >= minRating, pending: false }
    }

    const swatches = getSwatchInputs(item)
    const cachedWinner = swatches.find((input) => {
      const sid = (input.getAttribute("data-yotpo-product-id") || "").trim()
      const r = getCachedRating(sid)
      return typeof r === "number" && r >= minRating
    })
    if (cachedWinner) {
      const sid = (
        cachedWinner.getAttribute("data-yotpo-product-id") || ""
      ).trim()
      const autoKey = `${minRating}:${sid}`
      if (item.dataset.yotpoRatingAutoSwatch !== autoKey) {
        item.dataset.yotpoRatingAutoSwatch = autoKey
        if (!cachedWinner.classList.contains("active")) cachedWinner.click()
      }
      return { match: true, pending: false }
    }

    return { match: false, pending: true }
  }

  function applyGiftCenterFilters() {
    const minRating = getMinRatingFromUrl()
    const priceMax = getPriceMaxFromUrl()
    const mostGiftedActive = getMostGiftedFromUrl()
    const mostPopularValues = getMostPopularFromUrl()
    const hasAnyFilter =
      minRating != null ||
      priceMax != null ||
      mostGiftedActive ||
      mostPopularValues.length > 0

    const sections = Array.from(document.querySelectorAll(SELECTORS.section))
    let needsRetry = false

    sections.forEach((sectionEl) => {
      const items = sortByDefaultOrder(
        Array.from(sectionEl.querySelectorAll(SELECTORS.item)),
      )
      if (items.length === 0) return

      if (!hasAnyFilter) {
        items.forEach((item, idx) => {
          const visible = idx < MAX_VISIBLE_PER_SECTION
          item.classList.toggle(CLASSES.defaultHiddenItem, !visible)
          item.classList.remove(CLASSES.hiddenItem)
          clearAutoSwatchState(item)
        })
        setSectionVisibility(sectionEl, true)
        return
      }

      const matching = []
      const pending = []
      const priceSelected = priceMax != null
      const ratingSelected = minRating != null
      const hasRestFilterActive =
        mostGiftedActive || mostPopularValues.length > 0

      for (const item of items) {
        // Desired behavior:
        // - Price AND Rating (when selected).
        // - Remaining filters are OR with each other.
        // Overall: (Price? AND) (Rating? AND) (RestActive? AND (MostGifted OR MostPopular))

        if (priceSelected && !itemMatchesPrice(item, priceMax)) continue

        const ratingState = ratingSelected
          ? getRatingMatchState(item, minRating)
          : { match: true, pending: false }

        if (ratingSelected && !ratingState.match && !ratingState.pending)
          continue

        let restMatched = false
        if (mostGiftedActive && itemMatchesMostGifted(item, true)) {
          restMatched = true
        } else if (
          mostPopularValues.length > 0 &&
          itemMatchesMostPopular(item, mostPopularValues)
        ) {
          restMatched = true
        }

        if (hasRestFilterActive && !restMatched) continue

        if (ratingState.match) matching.push(item)
        else if (ratingState.pending) pending.push(item)
      }

      const source = matching.length ? matching : pending
      const toShow = new Set(source.slice(0, MAX_VISIBLE_PER_SECTION))
      items.forEach((item) => setItemVisibility(item, toShow.has(item)))
      const hasAny = matching.length > 0 || pending.length > 0
      setSectionVisibility(sectionEl, hasAny)
      if (pending.length) needsRetry = true
    })

    scheduleRetryIfNeeded(minRating != null && needsRetry)

    if (hasAnyFilter) {
      const allHidden = sections.every((s) => {
        const wrapper = s.closest(".shopify-section") || s
        return wrapper.classList.contains(CLASSES.hiddenSection)
      })
      toggleEmptyState(allHidden)
    } else {
      toggleEmptyState(false)
    }
  }

  function setPillVisible(pill, visible) {
    pill.style.display = visible ? "" : "none"
  }

  let visibilityCheckInFlight = false
  let visibilityRetryCount = 0
  function updateRatingPillVisibility() {
    if (visibilityCheckInFlight) return
    const pills = Array.from(
      document.querySelectorAll(SELECTORS.filterPill),
    ).filter((p) => getPillType(p) === "rating_min")
    if (!pills.length) return

    const params = new URLSearchParams(window.location.search)
    visibilityCheckInFlight = true
    try {
      for (const pill of pills) {
        const key = (pill.dataset.paramKey || "").trim()
        const value = (pill.dataset.paramValue || "").trim()
        if (!key || !value) continue

        // Never hide currently-selected pill (user needs a way to clear it).
        if ((params.get(key) || "").trim() === value) {
          setPillVisible(pill, true)
          continue
        }

        const min = parseNumberLikeRating(value)
        if (min == null) continue

        let hasAny = false
        const allItems = Array.from(document.querySelectorAll(SELECTORS.item))
        const hasAnyReadyWidget = !!document.querySelector(
          `${SELECTORS.item} .yotpo-widget-instance.yotpo-card-ready`,
        )
        const hasAnyRatingNumber = !!document.querySelector(
          `${SELECTORS.item} .yotpo-widget-instance .custom-yotpo-rating-number`,
        )
        for (const item of allItems) {
          const { rating } = cacheCardRatingFromItem(item)
          if (typeof rating === "number" && rating >= min) {
            hasAny = true
            break
          }
          const swatches = getSwatchInputs(item)
          if (
            swatches.some((s) => {
              const sid = (s.getAttribute("data-yotpo-product-id") || "").trim()
              const r = getCachedRating(sid)
              return typeof r === "number" && r >= min
            })
          ) {
            hasAny = true
            break
          }
        }

        // If Yotpo hasn't populated ratings yet, keep pill visible and retry later.
        if (!hasAny && !hasAnyReadyWidget && !hasAnyRatingNumber) {
          setPillVisible(pill, true)
        } else {
          setPillVisible(pill, hasAny)
        }
      }
    } finally {
      visibilityCheckInFlight = false
    }

    if (
      !document.querySelector(
        `${SELECTORS.item} .yotpo-widget-instance .custom-yotpo-rating-number`,
      ) &&
      visibilityRetryCount < 8
    ) {
      visibilityRetryCount += 1
      setTimeout(updateRatingPillVisibility, 500)
    } else {
      visibilityRetryCount = 0
    }
  }

  /** True if URL has any gift center filter (price, most_gifted, rating, most_popular). */
  function hasAnyGiftCenterFilter() {
    const params = getParams()
    if ((params.get("price_max") || "").trim()) return true
    if ((params.get("most_gifted") || "").trim() === "1") return true
    if ((params.get("yotpo_rating_min") || "").trim()) return true
    if (
      params
        .getAll("filter.p.m.custom.most_popular")
        .some((v) => (v || "").trim())
    )
      return true
    return false
  }

  function toggleClearAllVisibility() {
    const show = hasAnyGiftCenterFilter()
    document.querySelectorAll("[data-gift-center-clear-all]").forEach((el) => {
      el.style.display = show ? "inline-block" : "none"
    })
  }

  function syncPillUI() {
    const params = getParams()
    const mostPopularValues = getMostPopularFromUrl()
    document.querySelectorAll(SELECTORS.filterPill).forEach((pill) => {
      const key = (pill.dataset.paramKey || "").trim()
      const value = (pill.dataset.paramValue || "").trim()
      const type = getPillType(pill)

      let active = false
      if (key && value) {
        if (type === "most_popular") {
          active = mostPopularValues.includes(value)
        } else {
          const current = (params.get(key) || "").trim()
          if (type === "rating_min") {
            const currentNum = parseNumberLikeRating(current)
            const valueNum = parseNumberLikeRating(value)
            active =
              currentNum != null &&
              valueNum != null &&
              Math.abs(currentNum - valueNum) < 0.001
          } else {
            active = current === value
          }
        }
      }

      pill.classList.toggle(CLASSES.pillActive, active)
      pill.setAttribute("aria-pressed", active ? "true" : "false")
    })
    syncPriceDropdown()
    syncRatingDropdown()
    toggleClearAllVisibility()
  }

  let _cachedPriceDefaultLabel = null
  function syncPriceDropdown() {
    const wrap = document.querySelector("[data-gift-center-price-wrap]")
    if (!wrap) return
    const priceMax = getPriceMaxFromUrl()
    const pill = wrap.querySelector("[data-gift-center-price-pill]")
    const pillLabel = wrap.querySelector("[data-gift-center-price-pill-label]")
    const radios = document.querySelectorAll("[data-gift-center-price-radio]")
    const labels = document.querySelectorAll(".gift-center-price-label")
    const defaultLabel = _cachedPriceDefaultLabel || "Price"
    labels.forEach((l) => l.classList.remove("active"))
    let selectedText = defaultLabel
    radios.forEach((radio) => {
      const val = (radio.value || "").trim()
      const isChecked = (priceMax != null ? String(priceMax) : "") === val
      radio.checked = isChecked
      if (isChecked) {
        radio.closest(".gift-center-price-label")?.classList.add("active")
        if (val !== "") {
          const textEl = radio
            .closest(".gift-center-price-label")
            ?.querySelector(".gift-center-price-option-text")
          if (textEl && textEl.textContent)
            selectedText = textEl.textContent.trim()
        } else {
          selectedText = defaultLabel
        }
      }
    })
    if (pill) {
      pill.classList.toggle("selected", priceMax != null && priceMax > 0)
      pill.setAttribute(
        "aria-expanded",
        wrap.querySelector("[data-gift-center-price-details]")?.open ?? false,
      )
    }
    if (pillLabel) pillLabel.textContent = selectedText
    syncPriceAriaSelected(wrap)
  }

  function syncPriceAriaSelected(wrap) {
    if (!wrap) return
    const priceMax = getPriceMaxFromUrl()
    document.querySelectorAll("[data-gift-center-price-item]").forEach((li) => {
      const radio = li.querySelector("[data-gift-center-price-radio]")
      const val = (radio?.value || "").trim()
      const isSelected = priceMax != null && String(priceMax) === val
      li.setAttribute("aria-selected", isSelected ? "true" : "false")
    })
  }

  function getVisiblePriceOptions() {
    return Array.from(
      document.querySelectorAll("[data-gift-center-price-item]"),
    ).filter((li) => li.style.display !== "none")
  }

  function announcePriceSelection(wrap, text) {
    const liveEl = document.querySelector("[data-gift-center-price-live]")
    if (!liveEl) return
    liveEl.textContent = ""
    requestAnimationFrame(() => {
      liveEl.textContent = text
    })
  }

  let _cachedRatingDefaultLabel = null
  function syncRatingDropdown() {
    const wrap = document.querySelector("[data-gift-center-rating-wrap]")
    if (!wrap) return
    const minRating = getMinRatingFromUrl()
    const pill = wrap.querySelector("[data-gift-center-rating-pill]")
    const pillLabel = wrap.querySelector("[data-gift-center-rating-pill-label]")
    const radios = document.querySelectorAll("[data-gift-center-rating-radio]")
    const labels = document.querySelectorAll(".gift-center-rating-label")
    const defaultLabel = _cachedRatingDefaultLabel || "Top Rated"
    labels.forEach((l) => l.classList.remove("active"))
    let selectedVal = null
    radios.forEach((radio) => {
      const val = (radio.value || "").trim()
      const valNum = parseNumberLikeRating(val)
      const isChecked =
        minRating != null &&
        valNum != null &&
        Math.abs(minRating - valNum) < 0.001
      radio.checked = isChecked
      if (isChecked) {
        radio.closest(".gift-center-rating-label")?.classList.add("active")
        selectedVal = val
      }
    })
    if (pill) {
      pill.classList.toggle("selected", minRating != null)
      pill.setAttribute(
        "aria-expanded",
        wrap.querySelector("[data-gift-center-rating-details]")?.open ?? false,
      )
    }
    if (pillLabel) {
      pillLabel.textContent = selectedVal
        ? `${selectedVal}+ Rating`
        : defaultLabel
    }
    syncRatingAriaSelected(wrap)
  }

  /** Scroll pill container so the clicked pill is at the left (same as PLP). */
  function scrollPillToLeft(pill) {
    const container = document.querySelector(
      "[data-gift-center-filters] .quick-filter-main",
    )
    if (!container || !pill || !container.contains(pill)) return
    const cs = window.getComputedStyle(container)
    const gutter = parseInt(cs.paddingLeft, 10) || 0
    const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth)
    const targetLeft = Math.max(0, Math.min(pill.offsetLeft - gutter, maxLeft))
    container.scrollTo({ left: targetLeft, behavior: "smooth" })
  }

  /** Scroll pill row to start and keep 16px space on the left (deselect / clear all). */
  function scrollPillsToLeft() {
    const container = document.querySelector(
      "[data-gift-center-filters] .quick-filter-main",
    )
    if (!container) return
    // scrollLeft = 0 so container's left padding (16px) stays visible – pill never touches edge
    container.scrollTo({ left: 0, behavior: "smooth" })
  }

  function bindPills() {
    document.querySelectorAll(SELECTORS.filterPill).forEach((pill) => {
      pill.addEventListener("click", (e) => {
        const key = (pill.dataset.paramKey || "").trim()
        const value = (pill.dataset.paramValue || "").trim()
        const type = getPillType(pill)
        if (!key || !value) return

        e.preventDefault()
        retryCount = 0
        const clickedPill = e.currentTarget

        if (type === "most_popular") {
          const mostPopularBefore = getMostPopularFromUrl()
          const isDeselect = mostPopularBefore.includes(value)
          addOrRemoveParamValue(key, value)
          syncPillUI()
          applyGiftCenterFilters()
          updateRatingDropdownVisibility()
          updatePriceDropdownVisibility()
          requestAnimationFrame(() => {
            if (isDeselect) scrollPillsToLeft()
            else scrollPillToLeft(clickedPill)
          })
          document.dispatchEvent(
            new CustomEvent("gift-center:filters:change", {
              detail: { key, value, type },
            }),
          )
          return
        }

        const params = getParams()
        const current = (params.get(key) || "").trim()

        let next = value
        if (type === "rating_min") {
          const curNum = parseNumberLikeRating(current)
          const valNum = parseNumberLikeRating(value)
          if (
            curNum != null &&
            valNum != null &&
            Math.abs(curNum - valNum) < 0.001
          ) {
            next = null
          }
        } else if (type === "most_gifted" || type === "url_only") {
          if (current === value) next = null
        } else if (current === value) {
          next = null
        }

        setParamInUrl(key, next)
        syncPillUI()
        applyGiftCenterFilters()
        updateRatingDropdownVisibility()
        updatePriceDropdownVisibility()
        requestAnimationFrame(() => {
          if (next == null) scrollPillsToLeft()
          else scrollPillToLeft(clickedPill)
        })

        document.dispatchEvent(
          new CustomEvent("gift-center:filters:change", {
            detail: { key, value: next, type },
          }),
        )
      })
    })
  }

  /** Keep pill row at start so left gutter stays visible (for price dropdown at edge). */
  function scrollPillsToStart() {
    const container = document.querySelector(
      "[data-gift-center-filters] .quick-filter-main",
    )
    if (!container) return
    container.scrollTo({ left: 0, behavior: "smooth" })
  }

  function bindPriceDropdown() {
    const wrap = document.querySelector("[data-gift-center-price-wrap]")
    if (!wrap) return
    const details = wrap.querySelector("[data-gift-center-price-details]")
    const pill = wrap.querySelector("[data-gift-center-price-pill]")
    const radios = wrap.querySelectorAll("[data-gift-center-price-radio]")
    radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        retryCount = 0
        const val = (radio.value || "").trim()
        setParamInUrl("price_max", val || null)
        syncPillUI()
        applyGiftCenterFilters()
        syncPriceDropdown()
        updateRatingDropdownVisibility()
        updatePriceDropdownVisibility()
        requestAnimationFrame(() => scrollPillsToStart())

        const optText = radio
          .closest(".gift-center-price-label")
          ?.querySelector(".gift-center-price-option-text")
        announcePriceSelection(
          wrap,
          val
            ? `Selected: ${(optText?.textContent || val).trim()}`
            : "Price filter cleared",
        )

        document.dispatchEvent(
          new CustomEvent("gift-center:filters:change", {
            detail: { key: "price_max", value: val || null, type: "price" },
          }),
        )
      })
    })
    const dropdown = wrap.querySelector(".gift-center-price-dropdown")
    if (details && pill) {
      const dropdownParent = dropdown?.parentNode

      let touchedPrice = false
      pill.addEventListener("touchend", (e) => {
        e.preventDefault()
        touchedPrice = true
        details.open = !details.open
      })
      pill.addEventListener("click", (e) => {
        e.preventDefault()
        if (touchedPrice) {
          touchedPrice = false
          return
        }
        details.open = !details.open
      })

      function positionPriceDropdown() {
        if (!details.open || !pill || !dropdown) return
        const rect = pill.getBoundingClientRect()
        dropdown.style.left = `${rect.left}px`
        dropdown.style.top = `${rect.bottom + 8}px`
      }
      function closePriceDropdown() {
        if (!details.open) return
        details.removeAttribute("open")
      }
      _closePriceDropdownFn = closePriceDropdown

      details.addEventListener("toggle", () => {
        pill.setAttribute("aria-expanded", details.open)
        syncPriceAriaSelected(wrap)
        if (details.open) {
          if (_closeRatingDropdownFn) _closeRatingDropdownFn()
          if (dropdown) {
            document.body.appendChild(dropdown)
            dropdown.style.display = "block"
          }
          positionPriceDropdown()
          window.addEventListener("scroll", positionPriceDropdown, true)
          window.addEventListener("resize", positionPriceDropdown)
          requestAnimationFrame(() => {
            const items = getVisiblePriceOptions()
            const selected = items.find(
              (li) =>
                li.querySelector("[data-gift-center-price-radio]")?.checked,
            )
            const target = selected || items[0]
            if (target) target.focus()
          })
        } else {
          if (dropdown) {
            dropdown.style.display = "none"
            dropdownParent?.appendChild(dropdown)
          }
          window.removeEventListener("scroll", positionPriceDropdown, true)
          window.removeEventListener("resize", positionPriceDropdown)
        }
      })
      document.addEventListener("click", (e) => {
        if (!details.open) return
        if (!wrap.contains(e.target) && !dropdown?.contains(e.target)) {
          details.removeAttribute("open")
        }
      })
    }

    function handlePriceKeydown(e) {
      if (!details || !details.open) return
      const items = getVisiblePriceOptions()
      if (!items.length) return
      const currentIdx = items.indexOf(document.activeElement)

      switch (e.key) {
        case "ArrowDown": {
          e.preventDefault()
          const next = currentIdx < items.length - 1 ? currentIdx + 1 : 0
          items[next].focus()
          break
        }
        case "ArrowUp": {
          e.preventDefault()
          const prev = currentIdx > 0 ? currentIdx - 1 : items.length - 1
          items[prev].focus()
          break
        }
        case "Home":
          e.preventDefault()
          items[0].focus()
          break
        case "End":
          e.preventDefault()
          items[items.length - 1].focus()
          break
        case "Enter":
        case " ": {
          e.preventDefault()
          const focused = items[currentIdx]
          if (focused) {
            const radio = focused.querySelector(
              "[data-gift-center-price-radio]",
            )
            if (radio && !radio.checked) {
              radio.checked = true
              radio.dispatchEvent(new Event("change", { bubbles: true }))
            }
          }
          details.removeAttribute("open")
          pill.focus()
          break
        }
        case "Escape":
          e.preventDefault()
          details.removeAttribute("open")
          pill.focus()
          break
        case "Tab":
          details.removeAttribute("open")
          break
      }
    }
    wrap.addEventListener("keydown", handlePriceKeydown)
    if (dropdown) dropdown.addEventListener("keydown", handlePriceKeydown)
  }

  function getVisibleRatingOptions() {
    return Array.from(
      document.querySelectorAll("[data-gift-center-rating-item]"),
    ).filter((li) => li.style.display !== "none")
  }

  function announceRatingSelection(wrap, text) {
    const liveEl = document.querySelector("[data-gift-center-rating-live]")
    if (!liveEl) return
    liveEl.textContent = ""
    requestAnimationFrame(() => {
      liveEl.textContent = text
    })
  }

  function syncRatingAriaSelected(wrap) {
    const minRating = getMinRatingFromUrl()
    document
      .querySelectorAll("[data-gift-center-rating-item]")
      .forEach((li) => {
        const threshold = parseNumberLikeRating(
          li.getAttribute("data-rating-threshold"),
        )
        const isSelected =
          minRating != null &&
          threshold != null &&
          Math.abs(minRating - threshold) < 0.001
        li.setAttribute("aria-selected", isSelected ? "true" : "false")
      })
  }

  function bindRatingDropdown() {
    const wrap = document.querySelector("[data-gift-center-rating-wrap]")
    if (!wrap) return
    const details = wrap.querySelector("[data-gift-center-rating-details]")
    const pill = wrap.querySelector("[data-gift-center-rating-pill]")
    const dropdown = wrap.querySelector(".gift-center-rating-dropdown")
    const radios = wrap.querySelectorAll("[data-gift-center-rating-radio]")

    function selectRatingValue(val) {
      retryCount = 0
      setParamInUrl("yotpo_rating_min", val || null)
      syncPillUI()
      applyGiftCenterFilters()
      syncRatingDropdown()
      syncRatingAriaSelected(wrap)
      updateRatingDropdownVisibility()
      updatePriceDropdownVisibility()
      requestAnimationFrame(() => scrollPillsToStart())
      const textEl = val
        ? wrap.querySelector(
            `[data-rating-value="${val}"] .gift-center-rating-option-text`,
          )
        : null
      announceRatingSelection(
        wrap,
        textEl
          ? `Selected: ${textEl.textContent.trim()}`
          : "Rating filter cleared",
      )
      document.dispatchEvent(
        new CustomEvent("gift-center:filters:change", {
          detail: {
            key: "yotpo_rating_min",
            value: val || null,
            type: "rating",
          },
        }),
      )
    }

    radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        const val = (radio.value || "").trim()
        selectRatingValue(val)
      })
    })

    function closeDropdown() {
      if (_closeRatingDropdownFn) {
        _closeRatingDropdownFn()
      } else if (details && details.open) {
        details.removeAttribute("open")
      }
      if (pill) pill.focus()
    }

    function focusOption(optionLi) {
      if (!optionLi) return
      optionLi.focus()
      if (dropdown) {
        dropdown.setAttribute("aria-activedescendant", optionLi.id || "")
      }
    }

    function handleRatingKeydown(e) {
      if (!details.open) return
      const visibleOptions = getVisibleRatingOptions()
      if (!visibleOptions.length) return
      const currentFocused = document.activeElement?.closest(
        "[data-gift-center-rating-item]",
      )
      const currentIdx = currentFocused
        ? visibleOptions.indexOf(currentFocused)
        : -1

      switch (e.key) {
        case "ArrowDown": {
          e.preventDefault()
          const nextIdx =
            currentIdx < visibleOptions.length - 1 ? currentIdx + 1 : 0
          focusOption(visibleOptions[nextIdx])
          break
        }
        case "ArrowUp": {
          e.preventDefault()
          const prevIdx =
            currentIdx > 0 ? currentIdx - 1 : visibleOptions.length - 1
          focusOption(visibleOptions[prevIdx])
          break
        }
        case "Home": {
          e.preventDefault()
          focusOption(visibleOptions[0])
          break
        }
        case "End": {
          e.preventDefault()
          focusOption(visibleOptions[visibleOptions.length - 1])
          break
        }
        case "Enter":
        case " ": {
          e.preventDefault()
          if (currentFocused) {
            const radio = currentFocused.querySelector(
              "[data-gift-center-rating-radio]",
            )
            if (radio) {
              radio.checked = true
              selectRatingValue((radio.value || "").trim())
            }
          }
          closeDropdown()
          break
        }
        case "Escape":
        case "Tab": {
          closeDropdown()
          break
        }
      }
    }
    wrap.addEventListener("keydown", handleRatingKeydown)
    if (dropdown) dropdown.addEventListener("keydown", handleRatingKeydown)

    if (details && pill && dropdown) {
      const ratingDropdownParent = dropdown.parentNode
      let ratingDropdownOpen = false

      function positionRatingDropdown() {
        if (!pill || !dropdown) return
        const rect = pill.getBoundingClientRect()
        dropdown.style.left = `${rect.left}px`
        dropdown.style.top = `${rect.bottom + 8}px`
      }

      function openRatingDropdown() {
        if (ratingDropdownOpen) return
        if (_closePriceDropdownFn) _closePriceDropdownFn()
        ratingDropdownOpen = true
        details.setAttribute("open", "")
        pill.setAttribute("aria-expanded", "true")
        document.body.appendChild(dropdown)
        dropdown.style.display = "block"
        positionRatingDropdown()
        window.addEventListener("scroll", positionRatingDropdown, true)
        window.addEventListener("resize", positionRatingDropdown)
        try {
          updateRatingDropdownVisibility()
          syncRatingAriaSelected(wrap)
        } catch (_) {}
        requestAnimationFrame(() => {
          positionRatingDropdown()
          try {
            updateRatingDropdownVisibility()
          } catch (_) {}
          const visibleOptions = getVisibleRatingOptions()
          const selected = visibleOptions.find(
            (li) => li.getAttribute("aria-selected") === "true",
          )
          focusOption(selected || visibleOptions[0])
        })
      }

      function closeRatingDropdown() {
        if (!ratingDropdownOpen) return
        ratingDropdownOpen = false
        details.removeAttribute("open")
        pill.setAttribute("aria-expanded", "false")
        dropdown.style.display = "none"
        ratingDropdownParent.appendChild(dropdown)
        window.removeEventListener("scroll", positionRatingDropdown, true)
        window.removeEventListener("resize", positionRatingDropdown)
      }

      _closeRatingDropdownFn = closeRatingDropdown

      function toggleRatingDropdown() {
        if (ratingDropdownOpen) closeRatingDropdown()
        else openRatingDropdown()
      }

      let touchedRating = false
      pill.addEventListener("touchend", (e) => {
        e.preventDefault()
        e.stopImmediatePropagation()
        touchedRating = true
        toggleRatingDropdown()
      })
      pill.addEventListener("click", (e) => {
        e.preventDefault()
        e.stopImmediatePropagation()
        if (touchedRating) {
          touchedRating = false
          return
        }
        toggleRatingDropdown()
      })

      document.addEventListener("click", (e) => {
        if (!ratingDropdownOpen) return
        if (!wrap.contains(e.target) && !dropdown.contains(e.target)) {
          closeRatingDropdown()
        }
      })
    }
  }

  let ratingVisibilityCheckInFlight = false
  let ratingVisibilityRetryCount = 0

  /**
   * Best-known max rating for one gift-center card, and whether Yotpo is still loading.
   * Used to hide dropdown thresholds above the page max (e.g. hide 4.8+ when all ≤ 4.7).
   */
  function getGiftCenterItemMaxAndPending(item) {
    let maxVal = -Infinity
    const consider = (v) => {
      if (typeof v === "number" && Number.isFinite(v)) {
        maxVal = Math.max(maxVal, v)
      }
    }

    const { rating } = cacheCardRatingFromItem(item)
    consider(rating)

    getSwatchInputs(item).forEach((s) => {
      const sid = (s.getAttribute("data-yotpo-product-id") || "").trim()
      consider(getCachedRating(sid))
    })

    consider(parseNumberLikeRating(item?.dataset?.productRating))

    const r = readItemRating(item)
    consider(r)

    const widget = item.querySelector(".yotpo-widget-instance")
    const ready = widget?.classList?.contains("yotpo-card-ready")
    const suppressed =
      ready && widget?.classList?.contains("yotpo-card-suppressed")

    const pending =
      Boolean(widget) && !ready && !suppressed && maxVal === -Infinity

    const max = maxVal === -Infinity ? 0 : maxVal
    return { pending, max }
  }

  function updateRatingDropdownVisibility() {
    const wrap = document.querySelector("[data-gift-center-rating-wrap]")
    if (!wrap) return

    if (ratingVisibilityCheckInFlight) return
    ratingVisibilityCheckInFlight = true

    let globalPending = false
    try {
      const items = Array.from(document.querySelectorAll(SELECTORS.item))
      const ratingOptions = document.querySelectorAll(
        "[data-gift-center-rating-item]",
      )
      const priceMax = getPriceMaxFromUrl()
      const mostGiftedActive = getMostGiftedFromUrl()
      const mostPopularValues = getMostPopularFromUrl()
      const hasRestFilter = mostGiftedActive || mostPopularValues.length > 0

      let pageMax = 0
      for (const item of items) {
        if (priceMax != null && !itemMatchesPrice(item, priceMax)) continue
        if (hasRestFilter) {
          let restOk = false
          if (mostGiftedActive && itemMatchesMostGifted(item, true))
            restOk = true
          if (
            !restOk &&
            mostPopularValues.length > 0 &&
            itemMatchesMostPopular(item, mostPopularValues)
          )
            restOk = true
          if (!restOk) continue
        }
        const st = getGiftCenterItemMaxAndPending(item)
        if (st.pending) globalPending = true
        pageMax = Math.max(pageMax, st.max)
      }

      const currentMin = getMinRatingFromUrl()
      let anyOptionVisible = false

      ratingOptions.forEach((optionLi) => {
        const threshold = parseThreshold(
          optionLi.getAttribute("data-rating-threshold"),
        )
        if (threshold == null) return

        const isSelected =
          currentMin != null && Math.abs(currentMin - threshold) < 0.001
        if (isSelected) {
          optionLi.style.display = ""
          anyOptionVisible = true
          return
        }

        if (globalPending && pageMax === 0) {
          optionLi.style.display = ""
          anyOptionVisible = true
          return
        }

        if (pageMax + 1e-9 >= threshold) {
          optionLi.style.display = ""
          anyOptionVisible = true
        } else {
          optionLi.style.display = "none"
        }
      })

      wrap.style.display = anyOptionVisible ? "" : "none"
    } finally {
      ratingVisibilityCheckInFlight = false
    }

    if (globalPending && ratingVisibilityRetryCount < 20) {
      ratingVisibilityRetryCount += 1
      setTimeout(updateRatingDropdownVisibility, 400)
    } else {
      ratingVisibilityRetryCount = 0
    }
  }

  let priceVisibilityCheckInFlight = false
  let priceVisibilityRetryCount = 0

  function updatePriceDropdownVisibility() {
    const wrap = document.querySelector("[data-gift-center-price-wrap]")
    if (!wrap) return

    if (priceVisibilityCheckInFlight) return
    priceVisibilityCheckInFlight = true

    const minRating = getMinRatingFromUrl()
    const mostGiftedActive = getMostGiftedFromUrl()
    const mostPopularValues = getMostPopularFromUrl()
    const hasRestFilter = mostGiftedActive || mostPopularValues.length > 0
    const hasAnyNonPriceFilter = minRating != null || hasRestFilter
    let globalPending = false

    try {
      if (!hasAnyNonPriceFilter) {
        document
          .querySelectorAll("[data-gift-center-price-item]")
          .forEach((li) => {
            li.style.display = ""
          })
        wrap.style.display = ""
        return
      }

      const items = Array.from(document.querySelectorAll(SELECTORS.item))
      const priceOptions = document.querySelectorAll(
        "[data-gift-center-price-item]",
      )
      const currentPriceMax = getPriceMaxFromUrl()
      let anyOptionVisible = false

      priceOptions.forEach((optionLi) => {
        const label = optionLi.querySelector("[data-price-value]")
        const maxPriceStr = (label?.dataset?.priceValue || "").trim()
        const maxPrice = Number.parseInt(maxPriceStr, 10)
        if (!Number.isFinite(maxPrice) || maxPrice <= 0) return

        if (currentPriceMax != null && currentPriceMax === maxPrice) {
          optionLi.style.display = ""
          anyOptionVisible = true
          return
        }

        let hasMatch = false
        for (const item of items) {
          if (!itemMatchesPrice(item, maxPrice)) continue
          if (hasRestFilter) {
            let restOk = false
            if (mostGiftedActive && itemMatchesMostGifted(item, true))
              restOk = true
            if (
              !restOk &&
              mostPopularValues.length > 0 &&
              itemMatchesMostPopular(item, mostPopularValues)
            )
              restOk = true
            if (!restOk) continue
          }
          if (minRating != null) {
            const st = getGiftCenterItemMaxAndPending(item)
            if (st.pending) {
              globalPending = true
              hasMatch = true
              break
            }
            if (st.max + 1e-9 < minRating) continue
          }
          hasMatch = true
          break
        }

        optionLi.style.display = hasMatch ? "" : "none"
        if (hasMatch) anyOptionVisible = true
      })

      wrap.style.display = anyOptionVisible ? "" : "none"
    } finally {
      priceVisibilityCheckInFlight = false
    }

    if (globalPending && priceVisibilityRetryCount < 20) {
      priceVisibilityRetryCount += 1
      setTimeout(updatePriceDropdownVisibility, 400)
    } else {
      priceVisibilityRetryCount = 0
    }
  }

  /** Clear all: remove all gift center URL params and re-apply (same as PLP). */
  function bindClearAll() {
    document
      .querySelectorAll("[data-gift-center-clear-all]")
      .forEach((clearEl) => {
        clearEl.addEventListener("click", (e) => {
          e.preventDefault()
          const url = new URL(window.location.href)
          const preserveParams = ["q", "options[prefix]"]
          const preserved = {}
          preserveParams.forEach((key) => {
            if (url.searchParams.has(key))
              preserved[key] = url.searchParams.get(key)
          })
          ;[...url.searchParams.keys()].forEach((key) => {
            if (!preserveParams.includes(key)) url.searchParams.delete(key)
          })
          Object.keys(preserved).forEach((key) => {
            url.searchParams.set(key, preserved[key])
          })
          const target =
            url.pathname +
            (url.search.toString() ? "?" + url.search.toString() : "")
          history.replaceState({}, "", target)
          syncPillUI()
          applyGiftCenterFilters()
          updateRatingPillVisibility()
          updateRatingDropdownVisibility()
          updatePriceDropdownVisibility()
          requestAnimationFrame(() => scrollPillsToLeft())
        })
      })
  }

  /** Bleed scroll: drag-to-scroll on pills row (same as PLP). */
  function bindPillContainerDragScroll() {
    const container = document.querySelector("[data-gift-center-filters]")
    const pillContainer = container?.querySelector(".quick-filter-main")
    if (!pillContainer) return
    let isDown = false
    let startX
    let scrollLeft
    pillContainer.addEventListener("mousedown", (e) => {
      if (e.target.closest("[data-gift-center-price-wrap]")) return
      if (e.target.closest("[data-gift-center-rating-wrap]")) return
      isDown = true
      pillContainer.classList.add("dragging")
      startX = e.pageX - pillContainer.offsetLeft
      scrollLeft = pillContainer.scrollLeft
    })
    pillContainer.addEventListener("mouseleave", () => {
      isDown = false
      pillContainer.classList.remove("dragging")
    })
    pillContainer.addEventListener("mouseup", () => {
      isDown = false
      pillContainer.classList.remove("dragging")
    })
    pillContainer.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - pillContainer.offsetLeft
      const walk = (x - startX) * 1.5
      pillContainer.scrollLeft = scrollLeft - walk
    })
  }

  function init() {
    const priceWrap = document.querySelector("[data-gift-center-price-wrap]")
    const ratingWrap = document.querySelector("[data-gift-center-rating-wrap]")
    if (priceWrap) {
      const el = priceWrap.querySelector("[data-gift-center-price-pill-label]")
      _cachedPriceDefaultLabel = (el?.textContent || "").trim() || "Price"
    }
    if (ratingWrap) {
      const el = ratingWrap.querySelector(
        "[data-gift-center-rating-pill-label]",
      )
      _cachedRatingDefaultLabel = (el?.textContent || "").trim() || "Top Rated"
    }
    bindPills()
    bindPriceDropdown()
    bindRatingDropdown()
    bindClearAll()
    bindPillContainerDragScroll()
    syncPillUI()
    applyGiftCenterFilters()
    updateRatingPillVisibility()
    updateRatingDropdownVisibility()
    updatePriceDropdownVisibility()
    if (getPriceMaxFromUrl() != null || getMinRatingFromUrl() != null) {
      setTimeout(() => {
        applyGiftCenterFilters()
        updateRatingDropdownVisibility()
        updatePriceDropdownVisibility()
      }, 400)
    }
  }

  document.addEventListener("DOMContentLoaded", init)
  document.addEventListener("yotpo:card:refresh", () => {
    setTimeout(() => {
      retryCount = 0
      applyGiftCenterFilters()
      updateRatingPillVisibility()
      updateRatingDropdownVisibility()
      updatePriceDropdownVisibility()
    }, 0)
  })
  window.addEventListener("popstate", () => {
    retryCount = 0
    syncPillUI()
    applyGiftCenterFilters()
    updateRatingPillVisibility()
    updateRatingDropdownVisibility()
    updatePriceDropdownVisibility()
    toggleClearAllVisibility()
  })
})()
